import React from 'react';
import styled from 'styled-components/native';

import { padding } from '@src/configuration/constants';

import { Props } from './types';

const Header = styled.View`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};
`;

const Body = styled.View<{ open: boolean }>`
  width: 100%;
  height: ${({ open }) => (open ? 'auto' : 0)};
  transition: all 400ms ease-in-out;
`;

const Wrapper = styled.TouchableOpacity`
  width: 100%;
  overflow: hidden;
  padding: 0 ${padding}px;
  margin: 10px auto;
`;

function Accordion<T>(props: Props<T>) {
  const { list, body, header, keyExtractor } = props;
  const [activeIndex, setActiveIndex] = React.useState(-1);

  return list.map((item, i) => (
    <Wrapper key={keyExtractor(item)} onPress={() => setActiveIndex(i)}>
      <Header>{header(item, i, activeIndex === i)}</Header>
      <Body open={activeIndex === i}>{body(item)}</Body>
    </Wrapper>
  ));
}

export default Accordion;
